import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export function EventTicketsSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  useEffect(() => {
    window.gtag?.('event', 'purchase', { transaction_id: sessionId ?? undefined, items: [{ item_category: 'event_ticket' }] });
  }, [sessionId]);

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-b from-background to-muted/40 px-6">
      <div className="max-w-md text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
        <h1 className="mt-4 text-3xl font-bold tracking-tight">You're going!</h1>
        <p className="mt-3 text-muted-foreground">Your tickets are confirmed — a receipt is on its way to your email.</p>
        {sessionId && <p className="mt-6 font-mono text-xs text-muted-foreground">ref: {sessionId.slice(0, 24)}…</p>}
      </div>
    </div>
  );
}
